<template>
<div>
    <div class="mt-5 py-5 border-top text-center">
      <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <div class="card card-newshop--hover shadow" data-toggle="modal" data-target="#newShop">
                  <div class="card-body py-5 mt-12">
                    <div class="icon icon-shape icon-shape-primary rounded-circle mb-4">
                      <i class="ni ni-fat-add"></i>
                    </div>
                    <h6 class="text-primary text-uppercase"><b>เพิ่มร้านค้า</b></h6>
                  </div>
                </div>
              </div>

              <div class="col-lg-4" v-for="(shop , index) in rs_Shops" :key="index" >
                <div class="card card-lift--hover shadow border-0">
                  <div class="card-body py-3">
                    <div class="col-sm-12 mb-4">
                         <!--  -->
                      <img v-if="shop.shops_logourl != ''" :src="shop.shops_logourl" :alt="shop.shops_name" class="img-fluid rounded shadow-lg" style="width: 150px;">
                      <img v-else src="https://notebookspec.com/web/wp-content/uploads/2015/08/11218898_922406171134906_2433593294872393254_n.jpg" :alt="shop.shops_name" class="img-fluid rounded shadow-lg" style="width: 150px;">
                    </div>
                    <h6 class="text-primary text-uppercase">{{shop.shops_name}}</h6>
                    <p class="description mt-3">{{shop.shops_desc}}</p>
                    <div class="row text-center">
                        <!-- <div class="col-6">
                            <b>1,000</b><br>
                            <h5 class="badge badge-pill badge-warning">จำนวนค้างชำระ</h5>
                            จำนวนหมายเลข invoice ที่ถูกโอนเข้ามาแล้ว
                        </div>
                        <div class="col-6">
                            <b>฿ 1,000.00</b><br>
                            <h5 class="badge badge-pill badge-success">รายได้วันนี้</h5>
                            รายได้ต่อวันของร้านค้า
                        </div>   -->
                    </div>
                    <router-link :to="'/user/mangeshops/'+shop.shops_id+'/view'" class="btn btn-primary mt-4"><i class="ni ni-app"></i> จัดการ</router-link>
                  </div>
                </div>
                
                 <hr><!-- line as 1 components -->
              </div>
                
      
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade " ref="newShop" id="newShop" tabindex="-1" role="dialog" aria-labelledby="newShop" aria-hidden="true">
        <div class="modal-dialog modal- modal-dialog-centered modal" role="document">
            <div class="modal-content">

                <div class="modal-header">
                    <h6 class="modal-title" id="modal-title-default">เพิ่มร้านค้า</h6>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>

                <div class="modal-body">

                    
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>ชื่อร้านค้า</label>
                                                <input type="text" v-model="form_addShop.shops_name" class="form-control border-input" id="shop_name" name="shops_name" placeholder="ชื่อร้านค้า" value="">
                                            </div>
                                        </div>
                                       
                                    </div>
                                
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>ที่อยู่ของร้านค้า</label>
                                                <input type="url" v-model="form_addShop.shops_link" class="form-control border-input" id="url_input" name="shops_link" placeholder="https://..." value="">
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>ที่อยู่ของโลโก้ร้านค้า</label>
                                                <input type="text" class="form-control border-input" id="shops_logourl" name="shops_logourl" placeholder="https://..." value="" required>
                                            </div>
                                        </div>
                                    </div> -->
                                

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>รายละเอียดเกี่ยวกับร้านค้า</label>
                                                <textarea rows="3" v-model="form_addShop.shops_desc" class="form-control border-input" id="shop_desc" name="shops_desc" placeholder="รายละเอียดร้านค้า" value=""></textarea>
                                            </div>
                                        </div>
                                    </div>  
                                    <div class="clearfix"></div>
                                

                </div>

                <div class="modal-footer">
                
                    <button type="button" @click="addShops();" class="btn btn-primary">ยืนยัน</button>
                
                    <button type="button" class="btn btn-link  ml-auto" data-dismiss="modal">ยกเลิก</button>
                </div>

            </div>
        </div>
      </div>


</div>
</template>

<script>
import Shops from "@/stores/Shops";
import router from "@/router";
export default {
  name: 'Mangeshops',
  components: {
    // HelloWorld
  },
  data(){
      return {
          form_addShop:{
              shops_name: null,
              shops_link: null,
              shops_desc: null,
          },
          rs_Shops:[]
      }
  }, 
  methods: {
    checkUrl: function(){
            let input_value = this.form_addShop.shops_link;
        //Set input value to lower case so HTTP or HtTp become http
            input_value = input_value.toLowerCase();
        
        //Check if string starts with http:// or https://
        let regExr = /^(?:(http|https|ftp):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}(\/)?/i;
        
        //Test expression
        let result = regExr.test(input_value);
        
        //If http:// or https:// is not present add http:// before user input
        if (!result){
            // let new_value = "http://"+input_value+".com";
            // this.form_addShop.shops_link=new_value;
            alert('โปรดกรอกข้อมูลที่อยู่เว็บไซต์ให้ถูกต้อง')
            return false;
        }
        return true;
    },
    
    addShops: async function() {
        if(!this.checkUrl()){
            return;
        }

        if (!localStorage.access_token) router.push("/");
        if (

            this.form_addShop.shops_name == '' ||
            this.form_addShop.shops_link == '' ||
            this.form_addShop.shops_desc == '' ||

            this.form_addShop.shops_name == undefined ||
            this.form_addShop.shops_link == undefined ||
            this.form_addShop.shops_desc == undefined

            
            ) {
            return alert('โปรดกรอกข้อมูลให้ครบถ้วน')
        }
        let optionts = {
            access_token: localStorage.access_token,
            shops_name: this.form_addShop.shops_name,
            shops_link: this.form_addShop.shops_link,
            shops_desc: this.form_addShop.shops_desc
        };
        await Shops.dispatch("addShops", optionts);
        if (Shops.state.rs_addshop.status == 200) {
            alert("เพิ่มร้านค้าสำเร็จ")
            // this.$refs.newShop.hide()
            this.form_addShop = {
                shops_name: null,
                shops_link: null,
                shops_desc: null,
            }
            await this.showShops();

        } else if (Shops.state.rs_addshop.status == 400) {
            alert(Shops.state.rs_addshop.msg)
        }
      },
    showShops: async function() {
        if (!localStorage.access_token) router.push("/");
        let optionts = {
            access_token: localStorage.access_token,
        };
        await Shops.dispatch("showShops", optionts);
        // console.log(Shops.state.rs_Shops)
        if (Shops.state.rs_Shops.status == 200) {
            this.rs_Shops = Shops.state.rs_Shops.data
            
            // alert("อัพเดทข้อมูลสำเร็จ")
            // await this.getUser();
        } else if (Shops.state.rs_Shops.status == 400) {
            // alert(Shops.state.rs_Shops.msg)
            console.log(Shops.state.rs_Shops.msg)
        }
    },
},
    async mounted() {
      await this.showShops();
    }
};
</script>

<style>

  .card-newshop--hover{
      padding-top: 93px;
      padding-bottom: 50px;
      border: rgba(138, 152, 235, .5) dashed 4px;
  }
  .card-newshop--hover:hover
  {
      transition: all .15s ease;
      transform: translateY(-20px);
      border: #2643e9 dashed 4px !important;
      -webkit-transform: translateY(-20px);
      -moz-transform: translateY(-20px);
      -ms-transform: translateY(-20px);
      -o-transform: translateY(-20px);
  }
</style>
